import { LitElement, html, svg } from 'lit';

export class IconCirclePlus32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Sirkel med pluss</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 10v12M10 16h12M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15Z"></path></svg>`; }
}
if (!customElements.get('f-icon-circle-plus32', IconCirclePlus32)) {
  customElements.define('f-icon-circle-plus32', IconCirclePlus32);
}